export default __webpack_public_path__ + "static/frase3-4534d9068d32106004034d084f134eb0.png";